import { combineReducers } from 'redux';

import { jiraManagementReducer as jiraManagement } from 'redpoints-front-jira-management/JiraManagement';

import allIncidents from './allIncidents';
import incidentDetails from './incidentDetails';

const reporting = {
  allIncidents,
  incidentDetails,
  jiraManagement,
};

export default combineReducers(reporting);
